import React, { useEffect, useState } from 'react'
import { ResponsiveObject } from 'react-slick'
import { Image } from '@/atoms/Image'
import { AsH1, TitleLG } from '@/atoms/Text'
import { HorizontalItemScroller } from '@/molecules/HorizontalItemScroller'
import { PlaceholderMediaCard } from '@/molecules/MediaCard'
import { getNowStreamingProjects, NowStreamingContent } from '@/services/NowStreamingService'
import { logger } from '@/utils/logging'
import { isDefined } from '@/utils/types'

const defaultResponsiveSlick: ResponsiveObject[] = [
  {
    breakpoint: 1536,
    settings: {
      slidesToScroll: 6,
      slidesToShow: 6,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToScroll: 5,
      slidesToShow: 5,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToScroll: 4,
      slidesToShow: 4,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToScroll: 3,
      slidesToShow: 3,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToScroll: 2,
      slidesToShow: 2,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToScroll: 2,
      slidesToShow: 2,
    },
  },
]
export const GuildNowStreamingRail: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [nowStreamingProjects, setNowStreamingProjects] = useState<NowStreamingContent[]>([])

  useEffect(() => {
    const fetchNowStreamingProjects = async () => {
      try {
        const response = await getNowStreamingProjects()

        const definedProjects = response
          ?.filter(isDefined)
          .sort((a, b) => (a?.project?.releaseDate > b?.project?.releaseDate ? -1 : 1))
        setNowStreamingProjects(definedProjects ?? [])
      } catch (error) {
        logger().warn('Error fetching now streaming projects on Guild Winback View', error)
      } finally {
        setIsLoaded(true)
      }
    }

    if (!isLoaded) {
      fetchNowStreamingProjects()
    }
  }, [isLoaded])

  if (!nowStreamingProjects?.length) return null

  return (
    <div>
      <header>
        <TitleLG color="white" weight="bold" as={AsH1} className="mb-3 md:mb-4">
          Now Streaming
        </TitleLG>
      </header>

      <HorizontalItemScroller slidesToShow={6} slidesToScroll={6} responsive={defaultResponsiveSlick} arrows>
        {!isLoaded
          ? Array(7)
              .fill(0)
              .map((v, i) => (
                <PlaceholderMediaCard
                  className="mr-4"
                  borderRadiusClassName="rounded-lg"
                  hideTextPlaceholders
                  orientation="portrait"
                  key={i}
                />
              ))
          : nowStreamingProjects?.map((item) => {
              if (!item) return null
              if (!item?.image?.cloudinaryPath) return null
              const title = item.project.name ?? undefined

              return (
                <div key={item.id}>
                  <div className="mb-2 mr-4">
                    <Image
                      aria-label={title}
                      alt={title}
                      src={item?.image?.cloudinaryPath as string}
                      height={450}
                      width={300}
                      className="rounded-lg bg-black"
                      unoptimized={false}
                    />
                  </div>
                </div>
              )
            })}
      </HorizontalItemScroller>
    </div>
  )
}
